import { HeroUIProvider } from '@heroui/react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface ProvidersProps {
  children: React.ReactNode;
}

const Providers: React.FC<ProvidersProps> = ({ children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: EFfect executed on path change
  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant', // skip the scrolling animation
    });
  }, [pathname]);

  return (
    <HeroUIProvider className="min-h-dvh flex flex-col" navigate={navigate}>
      {children}
    </HeroUIProvider>
  );
};

export default Providers;
